import ToastAlertIcon from './ToastAlertIcon'

export default ToastAlertIcon